export const ExpiredTime = 60;

export const all_company = 'all_company'
export const all_stock = 'all_stock'

export const inputSearch = 'inputSearch'
export const price_stock_analysis = 'price_stock_analysis'
export const StockFilterParams = 'StockFilterParams'
